/**
 * 认证相关 API
 */
import apiClient from '@/config/api'

export interface LoginParams {
  gonghao: string
  password: string
}

export interface LoginResponse {
  token: string
  employee: {
    id: number
    gonghao: string
    name: string
    avatar?: string
    departmentName?: string
    position?: string
    isSuperAdmin?: boolean
    isCustomerService?: boolean
    email_enabled?: boolean
    menus: any[]
  }
}

export interface ChangePasswordParams {
  oldPassword: string
  newPassword: string
}

/**
 * 员工登录
 */
export const login = (params: LoginParams) => {
  return apiClient.post<any, LoginResponse>('/auth/login', params)
}

/**
 * 获取当前登录员工信息
 */
export const getMe = () => {
  return apiClient.get<any, LoginResponse['employee']>('/auth/me')
}

/**
 * 修改密码
 */
export const changePassword = (params: ChangePasswordParams) => {
  return apiClient.post('/auth/change-password', params)
}

